export default function secureApi(api: string): string{
    if(!api){
        return process.env.REACT_APP_API_URL!;
    }
    return process.env.REACT_APP_API_URL+api;
}